import React, { useState } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';

export default (asyncReducer) => (WrappedComponent) => {
  const WithDynamicReducer = (props) => {
    useState(useInjectReducerAndSaga(asyncReducer));
    return <WrappedComponent {...props} />;
  };
  WithDynamicReducer.displayName = `withReducer(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;
  hoistNonReactStatics(WithDynamicReducer, WrappedComponent);
  return WithDynamicReducer;
};
